import * as moment from 'moment';
import { Injectable } from '@angular/core';
import { DateTime } from 'luxon';

@Injectable({
  providedIn: 'root'
})
export class DateService {
  private readonly monthNames = [
    'January', 'February', 'March', 'April', 'May', 'June',
    'July', 'August', 'September', 'October', 'November', 'December'
  ];

  public todayDate: string;

  constructor() {
    const defaultDate = new Date();
    const day = defaultDate.getDate();
    const monthIndex = defaultDate.getMonth();
    const year = defaultDate.getFullYear();
    const formatted = DateTime.fromJSDate(defaultDate).toFormat('yyyy-MM-dd');
    const dateWithTimeZone = new Date(formatted + 'T00:00:00.000Z').toISOString()
    this.todayDate = `${day} ${this.monthNames[monthIndex]} ${year}`;
  }
}

export function formatDate(date: string, format = 'YYYY-MM-DD'): string {
  return moment(date).format(format);
}

export function formatDateNew(event: string): string {
  const date = new Date(event);
  const year = date.getFullYear();
  const month = ('0' + (date.getMonth() + 1)).slice(-2);
  const day = ('0' + date.getDate()).slice(-2);
  const formatted = `${year}-${month}-${day}`;
  return formatted
}

export function formatDateTo(event: string): string {
  const date = new Date(event);
  const year = date.getFullYear();
  const month = date.getMonth();
  const day = date.getDate();
  const endOfDayUTC = new Date(Date.UTC(year, month, day, 0, 0, 0));
  return endOfDayUTC.toISOString();
}
export function formatDateToo(event: string) {
  const formatted =
    DateTime.fromJSDate(event)
      .setLocale('en-GB')
      .toLocaleString(DateTime.DATE_FULL)
  return formatted
}

export function formatDateFrom(event: string): string {
  const date = new Date(event);

  const year = date.getFullYear();
  const month = date.getMonth();
  const day = date.getDate();

  const startOfDayUTC = new Date(Date.UTC(year, month, day, 0, 0, 0, 0));

  return startOfDayUTC.toISOString();
}

export function formatDateFromAndTo(event: string): string {
  // if (!event) {
  //   return '';
  // }
  const date = new Date(event);

  // if (isNaN(date.getTime())) {
  //   return '';
  // }

  const year = date.getFullYear();
  const month = date.getMonth();
  const day = date.getDate();

  const startOfDayUTC = new Date(Date.UTC(year, month, day, 0, 0, 0, 0));

  return startOfDayUTC.toISOString();
}
export function formatDateUTC(event: string): string {
  const date = new Date(event);
  const year = date.getUTCFullYear();
  const month = ('0' + (date.getUTCMonth() + 1)).slice(-2);
  const day = ('0' + date.getUTCDate()).slice(-2);
  return `${year}-${month}-${day}`;
}
export function toUTCMidnightISO(event: string): string {
  const date = new Date(event);
  return new Date(
    Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate(), 0, 0, 0, 0)
  ).toISOString();
}